import './ScenarioRunStatus.scss';

export interface IScenarioRunStatusProps {
    status?: string;
}

// The runner writes these statuses into the state document, so they are a contract with it rather than a set of
// display labels: a status it adds shows up as a neutral pill instead of breaking the page.
const passed = ['passed'];
// 'abandoned' is not written by the runner: the run list marks a run that stopped updating with it, because a
// process that disappeared leaves a state document that still says 'running'.
const failed = ['failed', 'timedout', 'aborted', 'abandoned'];
const busy = [
    'running',
    'configuring',
    'arranging',
    'acting',
    'waiting',
    'verifying',
];

// Exported so everything that summarises a run - a pill, a button, a suite card - sorts statuses the same way.
export const statusKind = (status: string) => {
    if (passed.includes(status)) return 'passed';
    if (failed.includes(status)) return 'failed';
    if (busy.includes(status)) return 'busy';
    return 'idle';
};

export const ScenarioRunStatus = ({ status }: IScenarioRunStatusProps) => {
    const value = (status ?? 'unknown').toLowerCase();

    return (
        <span className={`arl-run-status arl-run-status--${statusKind(value)}`}>
            {value}
        </span>
    );
};
